import {BaseSearchDTO} from "../baseSearchDTO.interface";

export interface VehicleFaultCategorySearchDTO extends BaseSearchDTO {
  filters?: {
  };
}
